import { defineMessages } from "react-intl"

export const SUPPLIER_DETAILS_MESSAGES = defineMessages({
    header_id: {
        id: "customer.supplier.components.supplier_details.header_id",
        defaultMessage: "ID"
    },
    header_value: {
        id: "customer.supplier.components.supplier_details.header_value",
        defaultMessage: "Value"
    },
    header_created_at: {
        id: "customer.supplier.components.supplier_details.header_created_at",
        defaultMessage: "Created at"
    },
    header_status: {
        id: "customer.supplier.components.supplier_details.header_status",
        defaultMessage: "Status"
    },
    button_create: {
        id: "customer.supplier.components.supplier_details.button_create",
        defaultMessage: "Create"
    }
})


// WEBPACK FOOTER //
// ./src/utils/contacts/messages.ts